import { render } from "./BaseContainerFillHeight.vue?vue&type=template&id=53e94524"
import script from "./BaseContainerFillHeight.vue?vue&type=script&lang=js"
export * from "./BaseContainerFillHeight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__